import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Banco de 100 Problemas Técnicos Resueltos',
    desc: '100 problemas de cálculo eléctrico aplicado: sección de conductores, caída de tensión, potencia instalada, corriente de diseño y selección de protecciones.',
    value: '$12.000'
  }, {
    num: '02',
    title: 'Kit de Simbología Eléctrica IRAM/AEA',
    desc: 'Láminas con los 80 símbolos eléctricos normalizados más utilizados en instalaciones domiciliarias e industriales.',
    value: '$8.500'
  }, {
    num: '03',
    title: 'Guía del Egresado Electricista',
    desc: 'Cómo presupuestar un trabajo de instalación eléctrica en Argentina hoy.',
    value: '$9.500'
  }, {
    num: '04',
    title: 'Rúbricas de Evaluación de Taller',
    desc: 'Rúbricas completas para evaluar el desempeño práctico del alumno en el taller. Terminá con el "pero profe, ¿por qué me pusiste esa nota?"',
    value: '$6.000'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark border-y border-brand-accent/20" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-2xl md:text-4xl font-black text-white" data-id="element-21">
            🎁 4 BONUS ESTRATÉGICOS
          </h2>
          <p className="text-base md:text-lg text-gray-400 mt-2" data-id="element-22">
            Recursos que completan tu arsenal docente
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-xl p-5 border border-white/10 hover:border-brand-accent/30 transition-colors relative overflow-hidden group" data-id="element-24">
              <div className="absolute -right-4 -top-4 w-20 h-20 bg-brand-accent/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-25"></div>

              <div className="flex items-start mb-3 relative z-10" data-id="element-26">
                <div className="bg-brand-accent text-white font-black text-lg w-10 h-10 rounded-lg flex items-center justify-center mr-3 shrink-0" data-id="element-27">
                  {bonus.num}
                </div>
                <div data-id="element-28">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-29">
                    <Gift className="w-3.5 h-3.5 text-brand-accent" data-id="element-30" />
                    <span className="text-brand-accent font-bold text-xs tracking-widest uppercase" data-id="element-31">
                      BONO {bonus.num}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold leading-tight text-white" data-id="element-32">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm text-gray-400 relative z-10 mb-2" data-id="element-33">
                {bonus.desc}
              </p>

              <p className="text-xs text-gray-600 relative z-10" data-id="element-34">
                Valor real:{' '}
                <span className="line-through" data-id="element-35">{bonus.value} ARS</span> —{' '}
                <span className="text-brand-accent font-bold" data-id="element-36">
                  HOY GRATIS con tu Kit
                </span>
              </p>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl p-4 text-center border border-brand-accent/20 max-w-xl mx-auto" data-id="element-37">
          <p className="text-lg md:text-xl font-medium text-gray-300" data-id="element-38">
            💰 Valor total bonos:{' '}
            <span className="line-through text-gray-600" data-id="element-39">$36.000 ARS</span>
            <br data-id="element-40" />
            <span className="text-brand-accent font-black neon-glow text-2xl" data-id="element-41">
              👉 HOY GRATIS con tu Kit
            </span>
          </p>
        </div>
      </div>
    </section>;
}